const initialState = {
    user: null,
    redirectError: null,
    isLoading: true
}

const authReducer = (state = initialState, action) => {
    switch(action.type){
        case 'LOGIN_REDIRECT_ERROR':
            return {...state, redirectError: action.payload, isLoading: false};
        case 'SET_USER':
            return {...state, user: action.payload, redirectError: null, isLoading: false};
        case 'LOGOUT':
            return {...state, user: null, isLoading: true};
        case 'SET_LOADING':
            return {...state, isLoading: action.payload};
        default:
            return state;
    }
}

export default authReducer